import { render } from "./PromoVerifier.vue?vue&type=template&id=07350ecf&scoped=true"
import script from "./PromoVerifier.vue?vue&type=script&lang=js"
export * from "./PromoVerifier.vue?vue&type=script&lang=js"

import "./PromoVerifier.vue?vue&type=style&index=0&id=07350ecf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07350ecf"]])

export default __exports__